module.exports = __webpack_public_path__ + "img/survey.e9979605.svg";